import { DEFAULT_THEME } from './themeConfig';

const THEME_STORAGE_PREFIX = 'simplycare.theme';

export const getThemeStorageKey = (user) => {
  const userKey = user?._id || user?.id || user?.email || 'guest';
  return `${THEME_STORAGE_PREFIX}.${userKey}`;
};

export const applyThemeVariables = (theme) => {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;
  const nextTheme = { ...DEFAULT_THEME, ...(theme || {}) };

  root.style.setProperty('--sidebar-bg', nextTheme.sidebarBg);
  root.style.setProperty('--sidebar-border', nextTheme.sidebarBorder);
  root.style.setProperty('--sidebar-item-bg', nextTheme.sidebarItemBg);
  root.style.setProperty('--sidebar-item-hover-bg', nextTheme.sidebarItemHoverBg);
  root.style.setProperty('--sidebar-active-bg', nextTheme.sidebarActiveBg);
  root.style.setProperty('--sidebar-text', nextTheme.sidebarText);
  root.style.setProperty('--sidebar-active-text', nextTheme.sidebarActiveText);
  root.style.setProperty('--page-bg', nextTheme.pageBg);
  root.style.setProperty('--color-primary', nextTheme.primary);
  root.style.setProperty('--color-primary-dark', nextTheme.primaryDark);
  root.style.setProperty('--color-heading', nextTheme.heading);
  root.style.setProperty('--button-text', nextTheme.buttonText);
};

export const loadThemeForUser = (user) => {
  try {
    const key = getThemeStorageKey(user);
    const raw = localStorage.getItem(key);
    if (!raw) {
      return {
        theme: { ...DEFAULT_THEME },
        defaultTheme: { ...DEFAULT_THEME },
      };
    }
    const parsed = JSON.parse(raw);
    return {
      theme: { ...DEFAULT_THEME, ...(parsed?.theme || {}) },
      defaultTheme: { ...DEFAULT_THEME, ...(parsed?.defaultTheme || {}) },
    };
  } catch (error) {
    return {
      theme: { ...DEFAULT_THEME },
      defaultTheme: { ...DEFAULT_THEME },
    };
  }
};

export const saveThemeForUser = (user, themeState) => {
  try {
    const key = getThemeStorageKey(user);
    localStorage.setItem(key, JSON.stringify(themeState));
  } catch (error) {
    // Intentionally ignored: failing to persist should not break UI behavior.
  }
};
